import { z } from "zod";

export type SystemMessage = z.infer<typeof SystemMessageSchema>;
export const SystemMessageSchema = z.object({
  type: z.string(),
  content: z.string(),
  metaData: z.any(),
});
